import OrganizationState from '@states/Organization';
import UserState from '@states/User';

/**
 * Updates organization credits by deducting the specified amount
 * @param {string} organizationId - The organization ID
 * @param {number} creditsToDeduct - Amount of credits to deduct
 */
const updateOrganizationCredits = (organizationId, creditsToDeduct) => {
  const targetOrganization = OrganizationState.organizations.find(
    org => org.organizationId === organizationId,
  );

  if (!targetOrganization) return;

  const currentCredits = targetOrganization.creditBalance ?? 0;
  if (currentCredits <= 0) return;

  const updatedOrganizations = OrganizationState.organizations.map(org =>
    org.organizationId === organizationId
      ? { ...org, creditBalance: currentCredits - creditsToDeduct }
      : org,
  );

  OrganizationState.setOrganizations(updatedOrganizations);
};

/**
 * Updates user credits by deducting the specified amount
 * @param {number} creditsToDeduct - Amount of credits to deduct
 */
const updateUserCredits = creditsToDeduct => {
  const currentCredits = UserState.user?.creditBalance ?? 0;
  if (currentCredits <= 0) return;

  UserState.setUser({
    ...UserState.user,
    creditBalance: currentCredits - creditsToDeduct,
  });
};

/**
 * Updates the current space's credits (either organization or user credits)
 * @param {number} creditsToDeduct - Amount of credits to deduct
 */
const updateCurrentSpaceCredits = creditsToDeduct => {
  const organizationId = getCurrentOrganizationId();

  if (organizationId) {
    updateOrganizationCredits(organizationId, creditsToDeduct);
  } else {
    updateUserCredits(creditsToDeduct);
  }
};

const getCurrentSpaceCredits = () => {
  const orgId = getCurrentOrganizationId();
  if (!orgId) return UserState.user?.creditBalance ?? 0;

  const org = (OrganizationState.organizations || []).find(
    o => o.organizationId === orgId,
  );

  if (!org) return 0;
  const orgCredits = org?.creditBalance ?? null;
  if (typeof orgCredits === 'number') return orgCredits;
};

const getCurrentOrganizationId = () => {
  return UserState.user?.selectedProjectsType === 'team'
    ? UserState.user?.selectedOrg
    : null;
};

export {
  getCurrentOrganizationId,
  getCurrentSpaceCredits,
  updateCurrentSpaceCredits,
};
